import { connect } from 'react-redux';
import PurchaseAmountView from './PurchaseAmountView';
import { currentClientId } from '../../../AdvWorkflow/AdvWorkflowSelector';
import { updateSupportData } from '../../../AdvWorkflow/AdvWorkflowActions';
import purchaseAmountSelector from './PurchaseAmountSelector';
import { BACKEND_KEY } from '../../LargePurchaseWorkflowConstants';
import onPostSave from '../PurchaseYear/PurchaseYearActions';
import { largePurchaseWorkflowCombinedData } from '../../LargePurchaseWorkflowSelector';
import { purchaseYearSelector, purchaseYearOptionsSelector } from '../PurchaseYear/PurchaseYearSelector';
import itemDescriptionSelector from '../ItemDescription/ItemDescriptionSelector';

const mapStateToProps = (state, ownProps) => ({
  clientId: currentClientId(state, ownProps),
  purchaseAmount: purchaseAmountSelector(state, ownProps),
  isNew: !(largePurchaseWorkflowCombinedData(state, ownProps).LargePurchaseGoal || {}).Id,
  goal: largePurchaseWorkflowCombinedData(state, ownProps).LargePurchaseGoal,
  purchaseYear: purchaseYearSelector(state, ownProps),
  purchaseYearOptions: purchaseYearOptionsSelector(state, ownProps),
  itemDescription: itemDescriptionSelector(state, ownProps),
});

const mapDispatchToProps = dispatch => ({
  store: workflowId => (data, clientId) => dispatch(updateSupportData(data, workflowId, clientId)),
  onPostProcess: goal => () => ({ [BACKEND_KEY]: goal }),
  onPostSave: (isNew, workflowId, clientId) => (data) => {
    dispatch(onPostSave(isNew, workflowId, clientId, data));
  },
});

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(PurchaseAmountView);
